// 변경이력: 2026-11-02 R52. Desktop 기관 가입 중 기존 계정 로그인도 안내 메뉴 없이 Native 복귀 화면으로 연결한다.
// filepath: /home/toofoocustomer/tf-node/tf_customer_web/components/customer/LoginForm.tsx

"use client";

import Link from "next/link";
import { FormEvent, useState } from "react";

import {
  customerAuthorizationAfterSignupUrl,
  customerIdentityErrorMessage,
  loginCustomer,
} from "@/lib/customer/identity-api";

type Props = {
  resume?: string;
};

function withResume(pathname: string, resume?: string): string {
  if (!resume) return pathname;
  const query = new URLSearchParams({ resume });
  return `${pathname}?${query.toString()}`;
}

export function LoginForm({ resume }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setErrorMessage("");
    setSubmitting(true);

    try {
      await loginCustomer(email.trim(), password, resume);
      window.location.assign(
        resume ? await customerAuthorizationAfterSignupUrl(resume) : "/account",
      );
    } catch (error) {
      setErrorMessage(customerIdentityErrorMessage(error, "login"));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form className="auth-form" onSubmit={submit} data-e2e="customer-login-form">
      <div className="form-field">
        <label htmlFor="email">이메일</label>
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="name@example.com"
          required
          maxLength={320}
        />
      </div>

      <div className="form-field">
        <div className="form-label-row">
          <label htmlFor="password">비밀번호</label>
          <Link className="field-link" href={withResume("/forgot-password", resume)}>비밀번호를 잊으셨나요?</Link>
        </div>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          placeholder="비밀번호 입력"
          required
          maxLength={72}
        />
      </div>

      {errorMessage ? (
        <div className="form-error" role="alert" data-e2e="customer-login-error">
          {errorMessage}
        </div>
      ) : null}

      <button className="primary-button" type="submit" disabled={submitting}>
        {submitting ? "로그인 중..." : "로그인"}
      </button>

      <p className="auth-switch">
        처음 이용하시나요? <Link href={withResume("/register", resume)}>회원가입</Link>
      </p>
    </form>
  );
}
